module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-ThinItalic-WebS-1ee05ca8f4e7d5840dc7bff342b650ec.woff2";